var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiFilledMegaphone124(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#141414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H7a4 4 0 010-8h2zM20.625 2.016a.5.5 0 00-.562.241c-1.577 2.831-6.272 4.733-9.669 4.733V7H10v13.284A1.877 1.877 0 0012 22a1.877 1.877 0 002-1.716v-4.7c2.532.77 5 2.251 6.063 4.156a.5.5 0 00.437.26.455.455 0 00.126-.017A.5.5 0 0021 19.5v-17a.5.5 0 00-.375-.484z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiFilledMegaphone124);
export default __webpack_public_path__ + "static/media/ui-filled-megaphone-1-24.8c531760.svg";
export { ForwardRef as ReactComponent };